/* eslint-disable @typescript-eslint/no-var-requires */
import { getQuartzConfig } from 'quartz-config/evaluable';
const quartzConfig = getQuartzConfig();
let getAuth = () => undefined;
if ( /* quartzConfig.auth === 'app' */false) {
  getAuth = require('./app/internal').getAppAuthResult;
} else if ( /* quartzConfig.auth === 'hubless' */false) {
  getAuth = require('./hubless/internal').getHublessAppAuthResult;
} else if ( /* quartzConfig.auth === 'tools' */false) {
  getAuth = require('./tools/internal').getHubSpotterAuthResult;
}
export const getAuthResult = getAuth;